import { Suspense, lazy } from 'react'
import { EventCountdownTimeDateContainer, Skeleton } from '@nv/components'
import { useVoterUserContext } from '@nv/contexts'
import BalletBox from '@nv/images/design/ballet-box-icon'
import { useTranslation } from 'react-i18next'
import styles from './VoterEventContent.module.scss'

const EventStatus = lazy(() => import('../event_status/EventStatus'))
const EventDescription = lazy(() => import('./components/EventDescription'))
const EventFooter = lazy(() => import('./components/EventFooter'))

export const VoterEventContent = ({ title, event, votingOpen, loadingVotingOpen }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const VoterUser = useVoterUserContext().voterUser
  const hasVoted = VoterUser.votedInEvents?.includes(event?.tiviId)

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <BalletBox />

        <div className={styles['content']}>
          <span className={styles['content__label']}>{t('events.voters.entitledTxt')}</span>

          <div className={styles['content__title']}>{title[currentLanguage]}</div>

          {event && event.description && (
            <Suspense fallback={<div>Loading description...</div>}>
              {!loadingVotingOpen ? <EventDescription description={event.description} showOneLine /> : <Skeleton width={400} />}
            </Suspense>
          )}

          {event && (
            <Suspense fallback={<div>Loading...</div>}>
              {!loadingVotingOpen ? (
                <EventStatus votingOpen={votingOpen} eventState={event.state} hasVoted={hasVoted} />
              ) : (
                <Skeleton width={200} />
              )}
              {!loadingVotingOpen ? (
                <EventCountdownTimeDateContainer votingOpen={votingOpen} event={event} size='small' />
              ) : (
                <Skeleton width={150} />
              )}
            </Suspense>
          )}
        </div>
      </div>

      {event && (
        <Suspense fallback={<div>Loading footer...</div>}>
          <EventFooter event={event} hasVoted={hasVoted} votingOpen={votingOpen} loadingVotingOpen={loadingVotingOpen} />
        </Suspense>
      )}
    </div>
  )
}
